require('./insuranceRequestView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { includes } = require('lodash');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const simulationActions = require('../../actions/insuranceRequest/insuranceRequestSimulation');
const insuranceRequestWizardActions = require('../../actions/insuranceRequest/insuranceRequestWizard');
// @ constants
const PATHS = {
    PROFILE: '/myprofile',
    SIMULATION: '/myprofile/insurances/home/simulation',
    GLOBAL: '/myprofile/global',
    ERROR: '/myprofile/insurance-error'
};

class InsuranceRequestView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            children: <LoadingSection />
        };
    }

    componentWillMount() {
        if (includes(this.props.history.location.pathname, PATHS.SIMULATION)) {
            const {
                history,
                match: { params: { token } },
                linkClient,
                setIsLoadingFromPublic
            } = this.props;

            if (!!token) {
                linkClient(token, history);
                setIsLoadingFromPublic();
            } else {
                this.props.history.push(PATHS.PROFILE);
            }
        } else {
            const { children } = this.props;

            this.setState({ children });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (includes(nextProps.history.location.pathname, PATHS.SIMULATION)) {
            const { history, match: { params: { token } }, linkClient } = nextProps;

            if (!!token) {
                linkClient(token, history);
            } else {
                this.props.history.push(PATHS.PROFILE);
            }
        } else {
            const { children } = nextProps;

            this.setState({ children });
        }
    }

    render() {
        return (
            <div className="mortgage-request-view">
                <section className="mortgage-request-view__content">
                    {this.state.children}
                </section>
            </div>
        );
    }
}

InsuranceRequestView.propTypes = {
    children: PropTypes.object,
    match: PropTypes.object,
    linkClient: PropTypes.func,
    setIsLoadingFromPublic: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = InsuranceRequestView;

module.exports = withRouter(connect(null, {
    linkClient: simulationActions.linkClient,
    setIsLoadingFromPublic: insuranceRequestWizardActions.setIsLoadingFromPublic
})(InsuranceRequestView));
